import React from 'react'
import { LayoutPageWrapper } from 'goustouicomponents/dist/LayoutPageWrapper'
import { Heading } from 'goustouicomponents/dist/Heading'
import css from './WhyWorkWithUs.module.css'

const WhyWorkWithUs = () => (
  <section className={css.wrapper}>
    <LayoutPageWrapper>
      <div className={css.contentContainer}>
        <div className={css.card}>
          <Heading type="h2" size="fontStyleXL" hasMargin={false}>
            Why work with us?
          </Heading>
          <p className={css.cardContent}>
            We’re obsessed with results and we love working together to overcome obstacles.
            We seek out people with the enthusiasm to try new things and the drive to get stuff done.
            Every day brings new things to learn, new challenges and of course, new recipes to test out!
          </p>
        </div>
      </div>
    </LayoutPageWrapper>
  </section>
)

export { WhyWorkWithUs }
